

import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTheme } from '@mui/material';
import { tokens } from '../../theme/theme';



function SkeletonTableLoader({ rows = 5, columns = 11 }) {
     const theme = useTheme();
        const colors = tokens(theme.palette.mode);
    return (
        <Box sx={{ width: '100%', padding: 2 }}>
            <style>
                {`
                    @keyframes shimmer {
                        0% { background-position: -200px 0; }
                        100% { background-position: 200px 0; }
                    }
                `}
            </style>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {Array.from({ length: columns }).map((_, index) => (
                            <TableCell key={index}>
                                <Skeleton
                                    variant="text"
                                    width="80%"
                                    height={30}
                                    sx={{
                                        background: 'linear-gradient(90deg, #44466a 25%, #1A1B2D 50%, #44466a 75%)',
                                        backgroundSize: '200px 100%',
                                        animation: 'shimmer 1.5s infinite',
                                    }}
                                />
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {Array.from({ length: columns }).map((_, colIndex) => (
                                <TableCell key={colIndex}>
                                    <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={40}
                                        sx={{
                                            background: 'linear-gradient(90deg, #44466a 25%, #1A1B2D 50%, #44466a 75%)',
                                            backgroundSize: '200px 100%',
                                            animation: 'shimmer 1.5s infinite',
                                        }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

export default SkeletonTableLoader;

